import Position from "../types/PositionType";
import { Canvas } from "./Canvas";
import { Enemy } from "./Enemy";
import { Sprite } from "./Sprite";

export class Projectile extends Sprite {
  private _velocity: Position = { x: 0, y: 0 };
  private _size: number;
  private _enemy: Enemy;

  constructor(
    position: Position,
    size: number,
    enemy: Enemy,
    canvas: Canvas,
    url: string,
    maxX: number = 1,
    maxY: number = 1
  ) {
    super(position, url, canvas, {
      maxX,
      maxY,
    });
    this._size = size;
    this._enemy = enemy;
  }

  public update() {
    this.draw();

    const angle = Math.atan2(
      this._enemy.center.y - this.position.y,
      this._enemy.center.x - this.position.x
    );

    const power = 6;
    this._velocity.x = Math.cos(angle) * power;
    this._velocity.y = Math.sin(angle) * power;

    this.position.x += this._velocity.x;
    this.position.y += this._velocity.y;
  }

  public get velocity(): Position {
    return this._velocity;
  }

  public set velocity(velocity: Position) {
    this._velocity = velocity;
  }

  public get size(): number {
    return this._size;
  }

  public set size(size: number) {
    this._size = size;
  }

  public get enemy(): Enemy {
    return this._enemy;
  }

  public set enemy(enemy: Enemy) {
    this._enemy = enemy;
  }
}
